import { makeActionCreator } from '../../config/store/utils'
import { getProvider } from '../../services/providers'

export const GET_PROVIDER = 'GET_PROVIDER'
export const GET_PROVIDER_ERROR = 'GET_PROVIDER_ERROR'
export const GET_PROVIDER_SUCCESS = 'GET_PROVIDER_SUCCESS'
export const onGetProvider = makeActionCreator(GET_PROVIDER)
export const onGetProviderError = makeActionCreator(GET_PROVIDER_ERROR, 'payload')
export const onGetProviderSuccess = makeActionCreator(GET_PROVIDER_SUCCESS, 'payload')
export const onGetProviderThunk = payload => async dispatch => {
  dispatch(onGetProvider())

  try {
    const { data } = await getProvider({ dni: payload.dni, year: payload.year })

    return dispatch(
      onGetProviderSuccess({
        amount: data?.payload?.amountCLP || 0,
        amountUSD: data?.payload?.amountUSD || 0,
        biddings: data?.payload?.numberLicAwarded || 0,
        dni: payload.dni,
        link: data?.payload?.link || '#',
        name: data?.payload?.supplier,
        orders: data?.payload?.numberOCAnnual || 0,
        ranking: data?.payload?.rankingAmount || 1,
        year: payload.year
      })
    )
  } catch (error) {
    return dispatch(onGetProviderError({ error }))
  }
}
